import { ReactNode } from 'react';

import { USER_ROLE } from 'api/users/users.model';
import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import { COMPANY } from 'models/company.model';

interface ProtectedComponentProps {
  children: ReactNode;
  role: USER_ROLE | USER_ROLE[];
  company?: COMPANY | COMPANY[];
}

const ProtectedComponent = ({ children, role, company }: ProtectedComponentProps) => {
  const { currentUser } = useAuthenticatedContext();

  let roles = role;
  let companies = company;

  if (!Array.isArray(role)) {
    roles = [role];
  }

  if (company && !Array.isArray(company)) {
    companies = [company];
  }

  if (
    currentUser &&
    roles.includes(currentUser.role) &&
    (companies?.includes(currentUser.company) ?? true)
  ) {
    return <>{children}</>;
  }

  return null;
};

export default ProtectedComponent;
